import type { AxiosInstance } from "axios";

import { parseAxiosResponse } from "@thalamos/common";
import type { ActivityPage, AssessmentId } from "@thalamos/haven-common";
import { ActivityResponseSchema } from "@thalamos/haven-common";

import type { ErrorBody, ResponseBody } from "../axios/api.js";
import { useApiAxios } from "../axios/api.js";

const parseResponseActivity = parseAxiosResponse(ActivityResponseSchema);

/** A page of an assessment's activity, as a caller asks for it. */
export type AssessmentActivityPaging = {
  limit?: number;
  offset?: number;
};

export const config = {
  assessmentActivity: {
    forAssessment: (
      assessmentId: AssessmentId,
      paging: AssessmentActivityPaging = {},
    ) => ({
      url: `/api/assessments/${assessmentId}/activity`,
      method: "get",
      params: {
        ...(paging.limit === undefined ? {} : { limit: paging.limit }),
        // Zero is the first page, so it has to survive a check a truthiness
        // test would drop.
        ...(paging.offset === undefined ? {} : { offset: paging.offset }),
      },
      transformResponse: parseResponseActivity,
    }),
  },
};

export const api = (apiAxios: AxiosInstance) => {
  return {
    assessmentActivity: {
      forAssessment: (
        assessmentId: AssessmentId,
        paging: AssessmentActivityPaging = {},
      ) =>
        apiAxios.request<ResponseBody<ActivityPage, ErrorBody>>(
          config.assessmentActivity.forAssessment(assessmentId, paging),
        ),
    },
  };
};

export const apiHooks = () => {
  return {
    assessmentActivity: {
      forAssessment: function useAssessmentActivity(
        assessmentId: AssessmentId,
        paging: AssessmentActivityPaging = {},
      ) {
        return useApiAxios<ActivityPage>(
          config.assessmentActivity.forAssessment(assessmentId, paging),
        );
      },
    },
  };
};
